import React, { useLayoutEffect } from "react";
import cn from "classnames";
import style from "./common.module.scss";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { useTranslation } from "react-i18next";
import OrderStatusDropdown from "./GroupByDropdown/OrderStatusDropdown";

const TopDirectionsMobile = ({ item, isExpeditor = false, isCompleted = true, setIsCompleted }) => {
  const { t } = useTranslation();
  
  useLayoutEffect(() => {
    const root = am5.Root.new("top-routes-mobile");
    root.setThemes([am5themes_Animated.new(root)]);
    root._logo?.dispose();

    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        layout: root.verticalLayout,
        wheelY: "zoomY",
        panY: true,
        panX: false,
        zoomY: true
      })
    );

    chart.plotContainer.setAll({
      paddingLeft: 0,
      paddingRight: 0,
      marginLeft: 0,
      marginRight: 0
    });

    const yAxis = chart.yAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "label",
        renderer: am5xy.AxisRendererY.new(root, {
          inversed: true,
          minGridDistance: 20
        }),
        tooltip: am5.Tooltip.new(root, {})
      })
    );

    yAxis.get("renderer").labels.template.set("visible", false);

    const xAxis = chart.xAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererX.new(root, {})
      })
    );

    xAxis.setAll({
      min: 0,
      strictMinMax: true,
    });

    yAxis.get("renderer").setAll({
      inside: true
    });

    const cursor = chart.set(
      "cursor",
      am5xy.XYCursor.new(root, {
        behavior: "zoomX"
      })
    );
    cursor.lineY.set("visible", false);

    const series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: "Route Count",
        xAxis: xAxis,
        yAxis: yAxis,
        valueXField: "count",
        categoryYField: "label",
        tooltip: am5.Tooltip.new(root, {
          labelText: "{fullRoute} — {valueX}"
        })
      })
    );

    series.columns.template.adapters.add("fill", (fill, target) => {
      return target.dataItem?.dataContext?.fill || fill;
    });
    series.columns.template.adapters.add("stroke", (stroke, target) => {
      return target.dataItem?.dataContext?.fill || stroke;
    });

    series.bullets.push((root, series, dataItem) => {
      return am5.Bullet.new(root, {
        locationX: 0,
        sprite: am5.Label.new(root, {
          text: dataItem.dataContext.fullRoute,
          centerX: 0,
          centerY: am5.percent(50),
          paddingLeft: 5,
          fill: am5.color(0x000000),
          fontSize: 12,
          fontWeight: "500",
          oversizedBehavior: "wrap",
          maxWidth: 120
        })
      });
    });

    const colors = [
      am5.color(0x845EC2),
      am5.color(0xD65DB1),
      am5.color(0xFF6F91),
      am5.color(0xFF9671),
      am5.color(0xFFC75F),
      am5.color(0xF9F871),
      am5.color(0x2C73D2),
      am5.color(0x008E9B),
      am5.color(0x00C9A7),
      am5.color(0x4D8076),
    ];

    const formattedData = item
      .filter(i => i.routeName)
      .map((i, index) => {
        const [from, to] = i.routeName.split(" - ").map(s => s.trim());
        return {
          label: `${from}\n  ↳ ${to}`,
          fullRoute: i.routeName,
          count: i.count,
          fill: colors[index % colors.length]
        };
      });

    yAxis.data.setAll(formattedData);
    series.data.setAll(formattedData);

    return () => root.dispose();
  }, [item]);

  return (
    <div className={style.content}>
      <div className={style.filter}>
        <span className={style.filter_title}>{t("analytics.topRoutes")}</span>
        {isExpeditor && <OrderStatusDropdown isCompleted={isCompleted} setIsCompleted={setIsCompleted} />}
      </div>
      <div className={style.area}>
        <div id="top-routes-mobile" className={style.area_chart}></div>
      </div>
    </div>
  );
};

export default TopDirectionsMobile;
